import './i18n/config';
import { useTranslation } from 'react-i18next';
import { US, FI } from 'country-flag-icons/react/3x2';

export function LanguageSelector() {
    const { i18n } = useTranslation();

    const currentLanguageFlag = i18n.language === 'en' ? <US></US> : <FI></FI>;
    const currentLanguageLabel = i18n.language === 'en' ? ' US' : 'FI';

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', pointerEvents: 'none' }}>
            {currentLanguageFlag}
            <span>{currentLanguageLabel}</span>
        </div>
    );
}